function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedTripleBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19.753c0-1.654 1.346-3 3-3h20c1.654 0 3 1.346 3 3V23H3v-3.247zM5 8c0-1.654 0-2 1-2h20c1 0 1 .5 1 2v6.855a4.916 4.916 0 00-1-.102H6a4.92 4.92 0 00-1 .102V8zM3 28v-3h26v3h2v-8.247c0-1.627-.793-3.061-2-3.975V8c0-2.757-1-4-3-4H6C4 4 3 5.243 3 8v7.778c-1.207.914-2 2.348-2 3.975V28h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13a3 3 0 013-3h14a3 3 0 010 6H9a3 3 0 01-3-3zm3-1a1 1 0 100 2h14a1 1 0 100-2H9z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15v-4h1.5v4H12zM18 15v-4h1.5v4H18z",
    fill: props.color
  }));
}

export default SvgIconBedTripleBedFilled;